import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=45677ab0"
import script from "./FileDropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDropzone.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports